import { getErrorCode, getErrorMessage } from '@/api/errors'
import { useAzureDevOpsAllWikis } from '@/hooks'
import { MenuBookIcon } from '@/components/icons'

interface WikiPickerProps {
  projectId: string
  enabled: boolean
}

export function WikiPicker({ projectId, enabled }: WikiPickerProps) {
  const { data: wikis = [], isLoading, isError, error } = useAzureDevOpsAllWikis(projectId, enabled)

  if (isLoading) {
    return <div role="status" aria-live="polite" className="text-sm text-muted-foreground">Loading wikis...</div>
  }

  if (isError) {
    if (getErrorCode(error) === 'WIKI_SCOPE_MISSING') {
      return <div role="alert" className="text-sm text-destructive">{getErrorMessage(error) ?? 'The token is missing the Wiki (Read) scope.'}</div>
    }

    return <div role="alert" className="text-sm text-destructive">Failed to load wikis.</div>
  }

  if (wikis.length === 0) {
    return <div className="text-sm text-muted-foreground">No wikis found.</div>
  }

  return (
    <div className="max-h-60 overflow-y-auto rounded-md border" aria-label="Azure DevOps wikis">
      {wikis.map((wiki) => (
        <div
          key={`${wiki.project}/${wiki.id}`}
          data-testid="connector-wiki-item"
          className="flex items-center gap-2 border-b px-3 py-2 last:border-b-0 hover:bg-muted/50"
        >
          <MenuBookIcon className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
          <span className="text-sm truncate">{wiki.project}/{wiki.name}</span>
        </div>
      ))}
    </div>
  )
}
